// conversationActions.ts
import { hotelActionTypes } from "./hotelTypes";

export const hotelApiResponseSuccess = (actionType: string, data: any) => ({
  type: hotelActionTypes.API_RESPONSE_SUCCESS,
  payload: { actionType, data },
});

// Action to handle API error
export const hotelApiResponseError = (actionType: string, error: string) => ({
  type: hotelActionTypes.API_RESPONSE_ERROR,
  payload: { actionType, error },
});






export const insertHotelAction = (response: any) => ({
  type: hotelActionTypes.INSERT_HOTEL,
  payload: response
});

export const updateHotelAction = (response: any) => ({
  type: hotelActionTypes.UPDATE_HOTEL,
  payload: response
});

export const deleteHotelDataAction = (response: any) => ({
  type: hotelActionTypes.DELETE_HOTEL_DATA,
  payload: response
});





export const getHotelAction = () => ({
  type: hotelActionTypes.GET_HOTEL,
  payload: {}
});
